<template>
  <v-card>
    <v-card-text>
      <params-component
          :items="items"
          :filters="filters"
          :filtersSelected="filtersSelected"
          :updateFilters="updateFilters"
          :weight="weight"
          :weightSelected="weightSelected"
          :updateWeight="updateWeight"
      ></params-component>

      <v-row>
        <v-col align="left">
          <span v-if="baseSize">Sample: {{ baseSize }}</span>
          <span v-if="sumWeight"> / </span>
          <span v-if="sumWeight">wSample: {{ sumWeight }}</span>
        </v-col>

        <v-col style="display: contents" ma>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" class="mr-2 mt-1" @click="saveScreenToExcel" v-if="rowsValue.length">
                <v-icon color="success">mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span>Выгрузить текущий результат</span>
          </v-tooltip>
          <v-switch
              v-if="hasNoneRow && rowsValue.length"
              v-model="noneRowInner"
              label="Строка none"
              class="mr-4"
          ></v-switch>
          <v-switch
              v-if="hasStrategy"
              v-model="volumes"
              label="Отображать объёмы"
              class="mr-4"
          ></v-switch>
        </v-col>
      </v-row>

      <table-component
          :headers="items"
          :hasStrategy="hasStrategy"
          :showVolumes="showVolumes"
          :rows="rows"
          :deleteRow="deleteRow"
          :copyRow="copyRow"
          :importance="importance"
          :categories="items"
          :rowsValue="rowsValue"
          :volumeSum="volumeSum"
          :saveRowChanges="saveRowChanges"
          :paramsValue="paramsValue"
          :addRow="addRow"
      ></table-component>
    </v-card-text>
  </v-card>
</template>

<script>
  import {ParamsComponent, TableComponent} from './'

  export default {
    name: "EditConcept",
    props: {
      items: Array,
      filters: Array,
      filtersSelected: Array,
      updateFilters: Function,
      weight: Array,
      hasStrategy: Boolean,
      showVolumes: Boolean,
      toggleShowVolumes: Function,
      weightSelected: String,
      updateWeight: Function,
      rows: Array,
      importance: Object,
      rowsValue: Array,
      volumeSum: Number,
      saveRowChanges: Function,
      paramsValue: Object,
      addRow: Function,
      baseSize: Number,
      sumWeight: String,
      updateData: Function,
      hasNoneRow: Boolean,
      noneRow: Boolean,
      deleteRow: Function,
      copyRow: Function,
      toggleNoneRow: Function,
      saveScreenToExcel: Function,
    },
    components: {
      ParamsComponent,
      TableComponent,
    },
    computed: {
      noneRowInner: {
        get: function () {
          return this.noneRow
        },
        set: function () {
          this.toggleNoneRow()
        },
      },
      volumes: {
        get() {
          return this.showVolumes
        },
        set() {
          this.toggleShowVolumes()
        }
      }
    },
  }
</script>
